export const firstLetters = name => {
  return name && name.length
    ? `${name[0].toUpperCase()}${name.split(' ')[1][0].toUpperCase()}`
    : null;
};

export const isNotPositiveNum = value => {
  return value === '' || isNaN(value) || value <= 0;
};

export const upperFirstLetter = str => {
  return str[0].toUpperCase() + str.slice(1);
};
